module.exports = __webpack_public_path__ + "img/linkedin.d8eac7f1.svg";